import moment from 'moment';

/**
 * Return format date
 * @param date incoming date
 */
export const formatDate = (date: Date | string): string => {
    return moment(date).format('LL').split(' ').slice(0, 2).join(' ');
};
